<div class="position-container" *ngIf="slot.position > 10">
  <span>--</span>
  <span></span>
  <span>--</span>
  <span>--</span>
  <span></span>
</div>

<div class="position-container" [class.isUser]="isUserSlot()">
  <ng-container *ngIf="isUserSlot() && slot.score === 0; else default">
    <span>--</span>
  </ng-container>
  <ng-template #default>
    <span>{{slot.position}}</span>
  </ng-template>

  <opac-avatar [picture]="slot.pictureUrl" [style.--background-color]="slot.color">
    {{slot.content}}
  </opac-avatar>
  <span>{{slot.userName}}</span>
  <span>{{slot.score}}</span>

  <span>
    <opac-icon *ngIf="slot.position <= 3" icon="medal"></opac-icon>
  </span>
</div>